define('shared/initializer/form/adapters/mixins/fields/util/updateTelephoneChuanr',[
    '../../../../constants',
    'shared/util/hub'
], function (constants, hub) {
    return function updateChuanr(form, phoneFormat) {
        var fieldPhone = form.items[constants.FIELD.PHONE];

        if (fieldPhone == null) {
            return;
        }

        hub.set('/form/lead/telephone/pattern', phoneFormat)
            .then(function () {
                fieldPhone.$el
                    .removeAttr('disabled')
                    .trigger('chuanr.refresh', {
                        forceClear: true
                    });
            });
    };
});
